export function isPollingResponse(response: {
  status: number;
  data?: { url?: string };
}) {
  return response.status === 202 && response.data?.url;
}
